import { render, staticRenderFns } from "./VCheckPreview.vue?vue&type=template&id=ded40cb4&"
import script from "./VCheckPreview.vue?vue&type=script&lang=js&"
export * from "./VCheckPreview.vue?vue&type=script&lang=js&"
import style0 from "./VCheckPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports